<ng-container *ngIf="shellV2; else oldShell">
  <div class="cc-shell">
    <span *ngIf="!isProd" class="cc-shell__test-line" aria-hidden="true"></span>
    <app-shell-sidebar></app-shell-sidebar>
    <div class="cc-shell__main">
      <app-shell-header></app-shell-header>
      <!-- `m-body`: the old pages (Metronic) take their paddings from `.m-body .m-content`, as in the old shell -->
      <main class="cc-shell__content m-body">
        <app-call-bar *ngIf="shell"></app-call-bar>
        <hc-alert></hc-alert>
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
  <app-shell-number-dialog></app-shell-number-dialog>
</ng-container>

<ng-template #oldShell>
  <app-header></app-header>

  <div class=" m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
    <app-sidebar class="m-grid__item m-aside-left  m-aside-left--skin-dark"></app-sidebar>
    <div class="m-aside-left-overlay m-menu__link"></div>

    <div class="hc-main-content">
      <app-call-bar *ngIf="shell"></app-call-bar>

      <hc-alert></hc-alert>

      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer></app-footer>
</ng-template>

<app-call-link-dialog *ngIf="shell"></app-call-link-dialog>
